import React, { useEffect, useState } from 'react';
import './HeaderNavBar.css';
import SearchMenu from './SearchMenu';
import ExportMenu from './ExportMenu';
import ContentMenu from './ContentMenu';
import OfflineMenu from './OfflineMenu';
import SettingsMenu from './SettingsMenu';
import HierarchyNavMenu from './HierarchyNavMenu';
import { Navbar, Nav, Modal } from 'react-bootstrap';
import { handleException } from "../../app/util/util";
function HeaderNavBar(props) {
    const { bookVO } = props;
    const { chapterId, bookId } = props.bookVO;
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const { userId, userRole, userRoleId, sessionAuthenticationToken } = props.userInfo;
    const closeModal = () => setState({ ...state, isModalOpenbrief: false });
    const [state, setState] = useState({ chapterList: [], navTocType: "none", isModalOpen: false, isModalOpenbrief: false });
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": sessionAuthenticationToken
        }
    }
    useEffect(() => {
        localStorage.setItem("bookVO", JSON.stringify(bookVO));
        getChapterAndSupplementalList();
    }, []);
    const getChapterAndSupplementalList = () => {
        let reqData = {
            "userVO": {
                "userId": userId,
                "userRole": userRole,
                "userRoleId": userRoleId,
                "userActivityVO": {
                    "lastReadSectionId": "",
                    "lastReadBookId": bookId,
                    "lastReadPageNum": "294",
                    "lastViewedOutlineId": "",
                    "pageNavigatingTo": "EReader",
                    "lastReadChapterId": chapterId,
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "lastReadParagraphId": "para01",
                    "lastReadSubSectionId": "subsec01",
                },
                "sessionVO": getSessionVO()
            },
            "bookVO": { "bookId": bookId },
        }
        const requestOptions1 = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/bookContentRetrievalService/getChapterAndSupplementalList`, requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data && data.status === "true") {
                    if (data.chapterVOList) {
                        let chapterVOList = data.chapterVOList;
                        chapterVOList= Array.isArray(chapterVOList) ? chapterVOList : [chapterVOList];
                        var chapterVOListNew = chapterVOList.map(chapter => {
                            return { ...chapter, chapter_select_status: false, default_chapter_select_status: false }
                        });
                        setState({ ...state, "chapterList": chapterVOListNew, "navTocType": data.navTocType })
                    } else if (data.sectionVOList) {
                        let sectionVOList = data.sectionVOList;
                        sectionVOList = Array.isArray(sectionVOList) ? sectionVOList : [sectionVOList];
                        var sectionVOListNew = sectionVOList.map(chapter => {
                            return { ...chapter, section_select_status: false, default_section_select_status: false }
                        });
                        setState({ ...state, "sectionVOList": sectionVOListNew, "navTocType": data.navTocType })
                    }
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    return (
        <>
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding stickyHeaderSet">
                <div id="blueStripContainer" className="bgColorBlueStrip" label="toolbar" aria-label="toolbar">
                    <Navbar collapseOnSelect expand="lg" aria-label="toolbar">
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="mr-auto navBarfontsize">
                                {
                                    state.navTocType === "flat" ?
                                        <ContentMenu bookVO={props.bookVO} chapterList={state.chapterList}></ContentMenu> :
                                        state.navTocType === "hierarchy" ?
                                            <HierarchyNavMenu bookVO={props.bookVO} sectionVOList={state.sectionVOList}></HierarchyNavMenu> : ""
                                }
                                <SearchMenu bookVO={props.bookVO}></SearchMenu>
                                <ExportMenu bookVO={props.bookVO} userVO={props.userInfo} />
                                <SettingsMenu bookVO={props.bookVO} briefVOList={props.briefVOList} annotationVOList={props.annotationVOList} userSettingsVO={props.userSettingsVO} />
                                {
                                    state.navTocType !== 'none' &&
                                    <OfflineMenu bookVO={props.bookVO} userVO={props.userInfo} navTocType={state.navTocType} chapterList={state.chapterList} sectionVOList={state.sectionVOList} />
                                }
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                    <Modal className="modal fade" show={state.isModalOpenbrief} onHide={closeModal} id="eBookStyleModalId" tabindex="-1" role="dialog" aria-labelledby="eBookStyleModalLabel" aria-hidden="true">
                        <div className="modal-header">
                            <h5 className="modal-title" id="eBookStyleModalLabel">Case Brief Highligters</h5>
                            <Modal.Header closeButton />
                        </div>
                        <div className="modal-body">
                            These changes will be applied to all case briefs for this book. Are you sure you want to make these changes?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary"
                                onClick={closeModal}>No, Go Back</button>
                        </div>
                    </Modal>
                </div>
            </div>
        </>
    )
}
export default HeaderNavBar;